import { useContext }                                            from "react";
import Link                                                      from "next/link";
import { Crown, ChevronRight }                                   from "lucide-react";
import Context                                                   from "@/provider/Context";
import Avatar                                                    from "@/components/Avatar";
import { link_do_perfil }                                        from "@/utils/MemberFunction";
import { cor_segura, com_alfa, formatar_valor, formatar_data,
  link_da_categoria }                                            from "@/utils/RpgFunction";

/* Um Rei de GET /rpg/reis: quem esta com o cargo (dono) ou, antes de o
   cargo ser entregue, quem esta na frente (primeiro do top). */
export default function ReiCard({ rei }) {
  const { Jogadores } = useContext(Context);
  if (!rei) return null;

  const cor       = cor_segura(rei.cor);
  const dono      = rei.dono || null;
  const pessoa    = dono || rei.top?.[0] || null;
  const href      = link_do_perfil(pessoa, Jogadores);
  const desde     = formatar_data(dono?.desde);
  const lista     = (Array.isArray(rei.atividades) ? rei.atividades : []).filter(Boolean);
  const atividades = lista.map((a) => a.nome).filter(Boolean).join(", ");
  const emojis    = lista.map((a) => a.emoji).filter(Boolean).join(" ");

  const conteudo = pessoa && (
    <>
      <div className="w-12 h-12 flex-shrink-0 rounded-lg overflow-hidden border-2" style={{ borderColor: cor }}>
        <Avatar src={pessoa.avatar} alt={pessoa.nome} className="w-full h-full object-cover" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-rajdhani font-semibold text-foreground truncate">{pessoa.nome}</p>
        <p className="text-xs text-muted-foreground truncate">
          {dono ? (desde ? `Rei desde ${desde}` : "Rei atual") : "Na frente · cargo ainda não entregue"}
        </p>
      </div>
      <span className="font-orbitron font-bold text-sm whitespace-nowrap" style={{ color: cor }}>
        {formatar_valor(pessoa.valor, rei.unidade)}
      </span>
    </>
  );

  return (
    <div className="void-card p-5 flex flex-col min-w-0" style={{ borderColor: com_alfa(cor, 0.45) }}>
      <div className="flex items-center gap-3 mb-4">
        <div className="p-3 rounded-xl flex-shrink-0" style={{ backgroundColor: com_alfa(cor, 0.15) }}>
          <Crown className="w-6 h-6" style={{ color: cor }} />
        </div>
        <div className="min-w-0">
          <h3 className="font-orbitron font-bold truncate" style={{ color: cor }}>{rei.nome}</h3>
          <p className="text-xs text-muted-foreground truncate" title={atividades}>
            {emojis} {atividades}
          </p>
        </div>
      </div>

      {pessoa ? (
        href ? (
          <Link href={href} className="flex items-center gap-3 p-3 rounded-lg bg-secondary/50 hover:bg-secondary transition-colors">
            {conteudo}
          </Link>
        ) : (
          <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/50">{conteudo}</div>
        )
      ) : (
        <p className="text-sm text-muted-foreground p-3 rounded-lg bg-secondary/50">
          Ninguém pontuou ainda. O trono está livre!
        </p>
      )}

      <Link
        href={link_da_categoria(rei.chave)}
        className="mt-4 text-sm text-primary hover:underline inline-flex items-center gap-1 self-start"
      >
        Ver ranking <ChevronRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
